export default __webpack_public_path__ + "static/media/pro-elevate-pyl-banner-3.046919a5.jpg";